import { useSelector } from 'react-redux';
import State, { AlertTypes } from 'types/State';
import { colors } from './styles/variables';

export default function Alerts(): JSX.Element {
  const alerts = useSelector((state: State) => state.alerts);

  return (
    <div className="snackbar">
      {alerts.map((alert) => {
        return (
          <div key={alert.uuid} className={`alert ${alert.type}`} data-testid="alert">
            {alert.message}
          </div>
        );
      })}
      <style jsx>
        {`
          .${AlertTypes.Error} {
            background-color: ${colors.ALR1};
          }

          .${AlertTypes.Success} {
            background-color: ${colors.ALG1};
          }

          .alert {
            height: 56px;
            padding: 15px;
            text-align: center;
          }

          .snackbar {
            z-index: 999999999;
            position: fixed;
            top: 0px;
            left: 0px;
            width: 100%;
            color: white;
            font-size: 18px;
            font-weight: 600;
          }
        `}
      </style>
    </div>
  );
}
